import { render, staticRenderFns } from "./FlowDetail.vue?vue&type=template&id=5d37be1f&"
import script from "./FlowDetail.vue?vue&type=script&lang=js&"
export * from "./FlowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d37be1f')) {
      api.createRecord('5d37be1f', component.options)
    } else {
      api.reload('5d37be1f', component.options)
    }
    module.hot.accept("./FlowDetail.vue?vue&type=template&id=5d37be1f&", function () {
      api.rerender('5d37be1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/FlowDetail.vue"
export default component.exports